import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getMetaPages = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.metapages}`, { params: req });
    return response;
}



export const postMetaPages = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.metapages}`, reqBody);
    return response;
}

export const patchMetaPages = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.metapages}`, reqBody);
    return response;
}

export const deleteMetaPages = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.metapages}`, { data: reqBody });
    return response;
}
